type CurrencyId = string | number;
type PocketCurrency = { ncode?: CurrencyId } & Record<string, unknown>;
type CurrencyRecord = { id?: CurrencyId; pocketCurrency?: PocketCurrency } & Record<string, unknown>;
type CurrencyInput = CurrencyRecord[] | CurrencyRecord | null | undefined;

export class CurrencyService {
    static getCurrentCurrency(currencies: CurrencyInput, amountCcy?: CurrencyId | null): CurrencyRecord | PocketCurrency | undefined {
        if (Array.isArray(currencies)) {
            if (currencies.length === 0) return undefined;
            if (!currencies[0]?.pocketCurrency) {
                return currencies.find((currency) => currency.id == amountCcy);
            }
            return currencies.find((currency) => currency.pocketCurrency?.ncode == amountCcy)?.pocketCurrency;
        }

        return currencies ?? undefined;
    }
}
